import { BasePlugin } from '../base'
import mdcSlider from './mdc-slider.vue'

export { mdcSlider }

export default BasePlugin({
  mdcSlider
})
